import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Target, Gift } from 'lucide-react';

/**
 * Aba Tarefas do afiliado — com sub-abas Ativas e Histórico.
 */
const TasksTab = ({ tasks = [], claims = [], claiming = {}, onClaim }) => {
  return (
    <Tabs defaultValue="tasks-active" className="w-full">
      <TabsList className="grid w-full grid-cols-2 bg-gray-100">
        <TabsTrigger
          value="tasks-active"
          data-testid="tab-tasks-active"
          className="data-[state=active]:bg-purple-600 data-[state=active]:text-white"
        >
          <Target className="w-4 h-4 mr-2" />
          Ativas
        </TabsTrigger>
        <TabsTrigger
          value="tasks-history"
          data-testid="tab-tasks-history"
          className="data-[state=active]:bg-emerald-600 data-[state=active]:text-white"
        >
          <Gift className="w-4 h-4 mr-2" />
          Histórico
        </TabsTrigger>
      </TabsList>

      <TabsContent value="tasks-active" className="mt-4">
        <div className="space-y-4">
          {tasks.map(({ task, progress = { current_sales_coins: 0, completed: false, reward_claimed: false } }) => {
            const percentage = task.target_sales_coins > 0
              ? Math.min((progress.current_sales_coins / task.target_sales_coins) * 100, 100)
              : 0;
            const canClaim = progress.completed && !progress.reward_claimed;

            return (
              <div key={task.id} className="border rounded-lg p-4 bg-gray-50">
                <div className="flex justify-between items-start mb-3">
                  <div>
                    <h4 className="font-bold">{task.title}</h4>
                    <p className="text-sm text-gray-600">{task.description}</p>
                  </div>
                  {canClaim && <Badge className="bg-green-600">Disponível!</Badge>}
                </div>
                <div className="space-y-2">
                  <div className="flex justify-between text-sm">
                    <span>Progresso</span>
                    <span className="font-bold">{Math.floor(percentage)}%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div className="bg-blue-500 h-2 rounded-full" style={{ width: `${percentage}%` }} />
                  </div>
                  <div className="flex justify-between text-xs text-gray-600">
                    <span>
                      {progress.current_sales_coins.toLocaleString()} / {task.target_sales_coins.toLocaleString()} moedas
                    </span>
                    <span className="font-bold text-green-600">Bônus: {task.reward_coins.toLocaleString()} 🎁</span>
                  </div>
                </div>
                {canClaim && (
                  <Button
                    onClick={() => onClaim(task.id)}
                    disabled={claiming[task.id]}
                    className="w-full mt-3 bg-green-600 hover:bg-green-700"
                  >
                    {claiming[task.id] ? 'Resgatando...' : `Resgatar ${task.reward_coins.toLocaleString()} Moedas`}
                  </Button>
                )}
              </div>
            );
          })}
        </div>
      </TabsContent>

      <TabsContent value="tasks-history" className="mt-4">
        <div className="mb-3 p-2 bg-blue-50 border border-blue-200 rounded text-[11px] text-blue-800">
          Histórico de <b>bônus de tarefas</b> resgatados. Os resgates da carteira de comissões aparecem na aba <b>Carteira</b>.
        </div>
        {claims.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            <Gift className="w-12 h-12 mx-auto mb-2 text-gray-400" />
            <p>Nenhum resgate ainda</p>
            <p className="text-xs mt-1">Complete tarefas para resgatar bônus</p>
          </div>
        ) : (
          <div className="space-y-3">
            {claims.map((claim) => (
              <div key={claim.id} className="border rounded-lg p-3 bg-green-50">
                <div className="flex justify-between items-start">
                  <div>
                    <p className="font-bold text-sm">{claim.task_title}</p>
                    <p className="text-xs text-gray-600">Mês: {claim.date}</p>
                    <p className="text-xs text-gray-600">
                      Resgatado: {claim.reward_claimed_at && new Date(claim.reward_claimed_at).toLocaleString('pt-BR')}
                    </p>
                    <p className="text-xs text-gray-600">Vendeu: {claim.current_sales_coins?.toLocaleString()} 🪙</p>
                  </div>
                  <Badge className="bg-green-600">+{claim.reward_coins?.toLocaleString()} 🎁</Badge>
                </div>
              </div>
            ))}
          </div>
        )}
      </TabsContent>
    </Tabs>
  );
};

export default TasksTab;
